import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconElectronicPrescription = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M35.913 19.007a.5.5 0 0 1 .5-.5h6.212a.5.5 0 1 1 0 1h-6.212a.5.5 0 0 1-.5-.5m4.147 9.487h-3.647a.5.5 0 1 0 0 1h3.647a.5.5 0 1 0 0-1m-7.083-5.701h-1.946v-1.947a.3.3 0 0 0-.3-.3h-1.814a.3.3 0 0 0-.3.3v1.947H26.67a.3.3 0 0 0-.3.3v1.814a.3.3 0 0 0 .3.3h1.947v1.947a.3.3 0 0 0 .3.3h1.814a.3.3 0 0 0 .3-.3v-1.947h1.946a.3.3 0 0 0 .3-.3v-1.814a.3.3 0 0 0-.3-.3m-14.42 13.676a.5.5 0 0 0 .5.5h4.929a.5.5 0 1 0 0-1h-4.93a.5.5 0 0 0-.5.5m1.73-24.438h2.47a.5.5 0 1 0 0-1h-2.47a.5.5 0 1 0 0 1M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24m-17.702 8.777h-6.946a1 1 0 0 1-1-1V16.223a1 1 0 0 1 1-1h6.946v-4.666a2 2 0 0 0-2-2H14.745a2 2 0 0 0-2 2v26.886a2 2 0 0 0 2 2h13.553a2 2 0 0 0 2-2zM47 24c0-2.44-.442-5.002-1.302-7.618l-.054-.159H23.352v15.554h22.292l.06-.18c.642-1.946 1.045-3.815 1.208-5.657l.007-.095Q47 24.92 47 24m-3.093-2.164h-7.494a.5.5 0 1 0 0 1h7.494a.5.5 0 1 0 0-1m0 3.328h-7.494a.5.5 0 1 0 0 1h7.494a.5.5 0 1 0 0-1',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconElectronicPrescription)
export default ForwardRef
